// extracted by mini-css-extract-plugin
export default {"wrap":"UserPanel_wrap__U4G39","info":"UserPanel_info__e5YzV","name":"UserPanel_name__ar3aO","role":"UserPanel_role__Yngkb","square":"UserPanel_square__04Wt4"};